import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants } from '..';

export const useOnlineContractConfigDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { id: number }) => {
      const res = await $api.delete(`/v1/online-contract/config/${data?.id}`);

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([contractConstants.queryKeys.ONLINE_CONTRACT_CONFIG]);
      }
    }
  );
};
